export const TRIAL_PRESETS = [
  { value: 'all', label: 'All invitations' },
  { value: 'attention', label: 'Needs attention' },
  { value: 'pending', label: 'Awaiting signup' },
  { value: 'trialing', label: 'In trial' },
  { value: 'expiring', label: 'Ends within 7 days' },
  { value: 'expired', label: 'Expired' },
  { value: 'converted', label: 'Converted' },
  { value: 'untracked', label: 'Untracked' },
  { value: 'accepted', label: 'Signed up' },
  { value: 'cancelled', label: 'Cancelled' },
];

export function getTrialAttentionReasons(invite) {
  const reasons = [];
  const delivery = invite.lifecycle_latest_delivery;
  if (delivery?.requires_manual_reconciliation) reasons.push('Uncertain email delivery');
  else if (delivery?.retry_exhausted) reasons.push('Email retries exhausted');
  else if (delivery?.status === 'failed') reasons.push(delivery.next_attempt_at ? 'Email retry scheduled' : 'Expiry email failed');
  if (invite.email_last_error) reasons.push('Onboarding email failed');
  if (invite.lifecycle_requires_review) reasons.push('Review notification settings');
  if (!invite.lifecycle_status && invite.is_latest_for_database === true) reasons.push('Email tracking missing');
  if (invite.lifecycle_notifications_enabled && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(invite.lifecycle_notification_email || '')) reasons.push('Notification recipient missing');
  return reasons;
}

export function matchesTrialPreset(invite, preset) {
  const managedTrial = ['trialing', 'expired'].includes(invite.lifecycle_status);
  const hasCountdown = Number.isFinite(invite.daysUntilExpiry);
  switch (preset) {
    case 'attention': return getTrialAttentionReasons(invite).length > 0;
    case 'pending': return invite.status === 'pending';
    case 'accepted': return invite.status === 'accepted';
    case 'trialing': return managedTrial && (hasCountdown ? invite.daysUntilExpiry >= 0 : invite.lifecycle_status === 'trialing');
    case 'expiring': return managedTrial && hasCountdown && invite.daysUntilExpiry >= 0 && invite.daysUntilExpiry <= 7;
    case 'expired': return managedTrial && hasCountdown ? invite.daysUntilExpiry < 0 : invite.lifecycle_status === 'expired' || (invite.status === 'expired' && !['converted', 'cancelled'].includes(invite.lifecycle_status));
    case 'converted': return invite.lifecycle_status === 'converted';
    case 'cancelled': return invite.lifecycle_status === 'cancelled';
    case 'untracked': return !invite.lifecycle_status && invite.is_latest_for_database === true;
    default: return true;
  }
}

export function filterTrialInvites(invites, { status = 'all', query = '' } = {}) {
  const terms = query.trim().toLowerCase().split(/\s+/).filter(Boolean);
  return invites.filter(invite => matchesTrialPreset(invite, status) && terms.every(term => [
    invite.company_name, invite.contact_first_name, invite.contact_last_name, invite.email,
    invite.database_name, invite.db_code, invite.plan_type, invite.lifecycle_notification_email,
    invite.accepted_user_id, invite.id,
  ].some(value => String(value ?? '').toLowerCase().includes(term))));
}

export function describeTrialFinalDay(invite) {
  const days = invite.daysUntilExpiry;
  if (!Number.isFinite(days)) return '';
  if (days === 0) return 'Final day today';
  if (days < 0) return `${Math.abs(days)} day${days === -1 ? '' : 's'} ago`;
  return `${days} day${days === 1 ? '' : 's'} remaining`;
}
